// extracted by mini-css-extract-plugin
module.exports = {"root":"PatientInfo_root__pNDOK","info":"PatientInfo_info__3iiht"};